// extracted by mini-css-extract-plugin
export default {"textGrid":"textGrid_textGrid__a85Qt","textGrid__body":"textGrid_textGrid__body__pQxyG","textGrid__aside":"textGrid_textGrid__aside__bRWZB"};